import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
import DatePicker from 'react-datepicker';

// Components
import Availability from './Availability';

const CustomAvailability = observer(class CustomAvailability extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      numberOfSeats: null,
      startDate: this.props.date,
      endDate: this.props.date,
      dayOfWeek: this.props.dayOfWeek,
      chooseDate: false
    };
  }

  async componentDidMount() {
    const {ScheduleStore} = this.props.store;

    const callback = (data) => {
      this.setState({ numberOfSeats: data.numberOfSeats})

    }

    ScheduleStore.getCalendar(this.props.locationSid, this.props.calendarSid, callback);

  }

  handleDateChange(date) {
    const endDate = moment(date).format('YYYY-MM-DD');

    // Check if we need to add days of the week
    const dayOfWeek = [...this.state.dayOfWeek];
    let filteredDayOfWeek = [];
    const momentStartDate = moment(this.state.startDate);
    const momentEndDate = moment(endDate);
    const duration = moment.duration(momentEndDate.diff(momentStartDate)).as('days');

    if(duration > 0) {
      for(let i = 1; i <= duration && i <= 7; i++) {
        const newDay = (dayOfWeek[i - 1] + 1) % 7;
        dayOfWeek.push(newDay);
      }

      // Remove duplicate days of week
      filteredDayOfWeek = dayOfWeek.filter((value, index, self) => {
        return self.indexOf(value) === index;
      });
    }

    this.setState({
      endDate,
      dayOfWeek: filteredDayOfWeek,
      chooseDate: false
    });
  }

  render() {
    const { translation } = this.props;

    return (
      <div>
        <header className="calendar__popup-head">
          <h4 className="subdued">
            <strong className="strong">
              {moment(this.state.startDate).format('MMMM D, YYYY')}
            </strong>

            {/* &nbsp;to&nbsp;

            <button
              className={`btn--link ${this.state.startDate === this.state.endDate ? 'subdued' : 'strong'}`}
              onClick={() => this.setState({chooseDate: true})}
            >
              {moment(this.state.endDate).format('MMMM D, YYYY')}
            </button> */}
          </h4>

          {this.state.chooseDate &&
            <DatePicker
              id="enddate"
              selected={this.state.endDate}
              onChange={(date) => this.handleDateChange(date)}
              minDate={this.state.startDate}
              placeholderText={translation.date_helper}
              required
              aria-required="true"
              autoFocus
              ref={(input) => this.endDate = input}
            />
          }
        </header>

          <Availability
              {...this.props}
              cleanedAvailabilities={this.props.cleanedAvailabilities}
              defaultNumberOfSeats={this.state.numberOfSeats}
              calendar={true}
              dayOfWeek={this.state.dayOfWeek}
              startDate={this.state.startDate}
              endDate={this.state.endDate}
          />
      </div>
    )
  }
})

export default translate('CustomAvailability')(CustomAvailability);



// WEBPACK FOOTER //
// ./src/app/components/Schedule/CustomAvailability.js